import XApi from './Api';
import XEndpoints from '../core/config/Endpoints';

export class UploadService {
  async upload(file: any) {
    const token = localStorage.getItem('token');
    if (token) {
      const response = await XApi.upload(XEndpoints.upload, {
        'Authorization': token,
      }, [file]);
      return response.data ?? [];
    }
    return [];
  }
}